<template>
  <v-footer
    padless
  >
    <v-col
      class="text-center"
      cols="12"
    >
      {{ date }} — <strong>123NET</strong>
    </v-col>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    date() {
      return new Date().getFullYear();
    },
  },
};
</script>
